import { createContext } from 'react';
import { IModifiers } from 'types';

export type TModifiersSortBy = '' | 'NameA-Z' | 'NameZ-A' | 'Price1-10' | 'Price10-1';
export type TModifiersCountOfItems = '12' | '24' | '48';
export type TTypeOfModalWindow = null | 'toConfirmDeleteItem' | 'success' | 'error';
export interface IFilterValues {
	searchString: string;
	IDSelectedCustomer: Nullable<string>;
	IDSelectedRestaurant: Nullable<string>;
	IDSelectedModifierGroup: Nullable<string>;
	priceFrom: string;
	priceTo: string;
	isShowOnlyComboItems: boolean;
	sortBy: TModifiersSortBy;
	countOfItems: TModifiersCountOfItems;
	isDisabledModifier: boolean;
	isRestrictedModifier: boolean;
	currentPage: number;
}

export interface IModifiersState {
	modifiers: IModifiers;
	searchString: string;
	IDSelectedCustomer: Nullable<string>;
	IDSelectedRestaurant: Nullable<string>;
	IDSelectedModifierGroup: Nullable<string>;
	priceFrom: string;
	priceTo: string;
	isShowOnlyComboItems: boolean;
	sortBy: TModifiersSortBy;
	countOfItems: TModifiersCountOfItems;
	isDisabledModifier: boolean;
	isRestrictedModifier: boolean;
	currentPage: number;
	IDForDeletion: string;
	IDForFullInfo: string;
	typeOfModalWindow: TTypeOfModalWindow;
}

export const modifiersInitialState: IModifiersState = {
	modifiers: { modifiersCount: 0, modifiers: [] },
	searchString: '',
	IDSelectedCustomer: null,
	IDSelectedRestaurant: null,
	IDSelectedModifierGroup: null,
	priceFrom: '',
	priceTo: '',
	isShowOnlyComboItems: false,
	sortBy: '',
	countOfItems: '12',
	isDisabledModifier: false,
	isRestrictedModifier: false,
	currentPage: 1,
	IDForDeletion: '',
	IDForFullInfo: '',
	typeOfModalWindow: null,
};

export interface IModifiersContext extends IModifiersState {
	deleteSelectedItem(): void;
	changeSearchString(value: string): void;
	setIDCustomer(value: Nullable<string>): void;
	setIDRestaurant(value: Nullable<string>): void;
	setIDModifierGroup(value: Nullable<string>): void;
	changePriceFrom(value: string): void;
	changePriceTo(value: string): void;
	toggleShowOnlyComboItems(): void;
	resetSelectedControls(): void;
	setSortBy(sortBy: TModifiersSortBy): void;
	setCountOfItems(count: TModifiersCountOfItems): void;
	toggleIsDisabledModifiers(): void;
	toggleIsRestrictedModifiers(): void;
	changeCurrentPage(page: number): void;
	setIDForDeletion(value: string): void;
	setIDForFullInfo(value: string): void;
	changeTypeOfModalWindow(value: TTypeOfModalWindow): void;
	setFiltersFromQueryString(value: IFilterValues): void;
}

export const ModifiersContext = createContext<IModifiersContext>({
	deleteSelectedItem: () => undefined,
	changeSearchString: () => undefined,
	setIDCustomer: () => undefined,
	setIDRestaurant: () => undefined,
	setIDModifierGroup: () => undefined,
	changePriceFrom: () => undefined,
	changePriceTo: () => undefined,
	toggleShowOnlyComboItems: () => undefined,
	resetSelectedControls: () => undefined,
	setSortBy: () => undefined,
	setCountOfItems: () => undefined,
	toggleIsDisabledModifiers: () => undefined,
	toggleIsRestrictedModifiers: () => undefined,
	changeCurrentPage: () => undefined,
	setIDForDeletion: () => undefined,
	setIDForFullInfo: () => undefined,
	changeTypeOfModalWindow: () => undefined,
	setFiltersFromQueryString: () => undefined,
	...modifiersInitialState,
});
